<script lang="ts">
	import ShellLayout from "./ShellLayout.svelte";
	import AddSuggestion from "./AddSuggestion.svelte";
</script>

<ShellLayout><AddSuggestion /></ShellLayout>
